var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerRedRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 17.3332C4.39752 17.3332 0.666687 13.6023 0.666687 8.99984C0.666687 4.39734 4.39752 0.666504 9.00002 0.666504C13.6025 0.666504 17.3334 4.39734 17.3334 8.99984C17.3334 13.6023 13.6025 17.3332 9.00002 17.3332ZM8.16669 11.4998V13.1665H9.83335V11.4998H8.16669ZM8.16669 4.83317V9.83317H9.83335V4.83317H8.16669Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerRedRound);
export default __webpack_public_path__ + "static/media/danger-red-round.83117211fec63ad8679f54d6dc267244.svg";
export { ForwardRef as ReactComponent };